import React from "react"
import { Container } from "reactstrap"
import { StaticImage } from "gatsby-plugin-image"
import  * as s  from './style.css'

export default function index() {



  return (
    <div className="gallery position-relative">
      <img alt="" style={{position: "absolute", right: 0 }} src={require("./images/splash.svg").default} />
      <Container>

        <div className="gallery">

          <div className="column">
            <div className="image-item">
              <StaticImage
                placeholder="tracedSVG"
                className={s.imageItemImg}
                alt="narciarz na sniegu"
                src="./images/gallery1.jpg"
              />
            </div>
            <div className="image-item">
              <StaticImage
                placeholder="tracedSVG"
                className={s.imageItemImg}
                alt="narciarz na sniegu"
                src="./images/gallery2.jpg"
              />
            </div>
            <div className="image-item">
              <StaticImage
                placeholder="tracedSVG"
                className={s.imageItemImg}
                alt="narciarz na sniegu"
                src="./images/gallery3.jpg"
              />
            </div>
            <div className="image-item" >
              <StaticImage
                placeholder="tracedSVG"
                className={s.imageItemImg}
                alt="narciarz na sniegu"
                style={{ filter: "grayscale(100%)", margin: 0, borderRadius: "10px", height: "169px" }}
                src="./images/kajak3.jpg"
              />
            </div>
          </div>

          <div className="column">
            <div className="image-item">
              <StaticImage
                placeholder="tracedSVG"
                className={s.imageItemImg}
                alt="narciarz na sniegu"
                src="./images/gallery5.jpg"
              />
            </div>
            <div className="image-item">
              <StaticImage
                placeholder="tracedSVG"
                className={s.imageItemImg}
                alt="narciarz na sniegu"
                src="./images/gallery6.jpg"
              />
            </div>
          </div>

          <div className="column">
            <div className="image-item">
              <StaticImage
                placeholder="tracedSVG"
                className={s.imageItemImg}
                alt="narciarz na sniegu"
                src="./images/gallery7.jpg"
              />
            </div>
            <div className="image-item">
              <StaticImage
                placeholder="tracedSVG"
                className={s.imageItemImg}
                alt="narciarz na sniegu"
                src="./images/gallery8.jpg"
              />
            </div>
          </div>
        </div>
      </Container>
    </div>
  )
}
